<template>
<div id="eval_new_step1" class="flex">

    <titlePage>
        <template slot="titleBody">
            <h1 class="title is-size-1 has-text-weight-bold stepTitle page-title" v-if="isNew">
                {{ $t('modules.positions.formStep1.title') }}
            </h1>
            <!-- <h1 class="title is-size-1 has-text-weight-bold stepTitle page-title" v-else>{{currentPosition.name}}</h1> -->
        </template>
    </titlePage>


    <div class="hero flex subsection_container">

        <div class="hero-body flex_content">
            <div class="container  micro-container has-text-centered">

            <h2 class="title is-size-1 has-text-weight-light stepTitle" v-if="isNew">
                {{ $t('modules.positions.formStep1.inputLabelNew') }}

                </h2>
            <h2 class="title is-size-1 has-text-weight-light stepTitle" v-else>
                {{ $t('modules.positions.formStep1.inputLabelEdit') }}
            </h2>


            <div class="form_material_container">
                <InputMaterialWrap
                    v-model="currentPosition.name"
                    label=""
                    class="big_input"
                    validate='required'
                    input-id="positionName"
                    @input="updateFormData">
                </InputMaterialWrap>

                <btn-circle-icon
                    :class="{disabled: !isFormValid}"
                    class="large is-cursor"
                    icon="icon-arrow-right"
                    @click.native="nextStep" />
            </div>

            </div>
        </div>
    </div>
</div>


</template>

<script>
import TitlePage from "@/components/layouts/titlePage"

export default {
    name: 'FormEvalStep1',
    props: ['isNew'],
    components: {
        TitlePage
    },
    data(){
        return {}
    },
    computed: {
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        },
        isFormValid(){
            return this.currentPosition.name != ""
        },
    },
    methods: {
        nextStep(){
            this.$validator.validateAll()
            if(this.isFormValid){
                this.$store.commit('PositionStore/changeCurrentStep', { index: 1 })
            }
        },
        updateFormData(formData){
            this.$store.commit('PositionStore/updateFormValidity', { index: 0, validity: this.isFormValid } )
            this.$store.commit('PositionStore/updatePositionData', this.currentPosition )
        }
    }
}
</script>

<style lang="scss" scoped>
#eval_new_step1{
    background: $white;
    display: flex;
    flex-direction: column;
    .subsection_container{
        .hero-body{
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>